export const useLang = (_lang: ELocale) => {
  const runtimeConfig = useRuntimeConfig()
  const i18nStore = useI18nStore()
  const { locale, t: $t } = useI18n()

  let lang = runtimeConfig.public.lang
  i18nStore.setLang(_lang)
  if (_lang == ELocale.en) {
    lang = 'en'
    locale.value = 'en'
  } else if (_lang == ELocale.cn || _lang == ELocale.zh) {
    lang = 'cn'
    locale.value = 'zh'
  }
  return { lang, $t }
}
